function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2.13379C24.8224 2.13379 32 7.39733 32 13.8671C32 17.5583 29.6229 21.0372 25.6177 23.2468L27.7029 29.1562C27.7766 29.3645 27.7141 29.5968 27.5458 29.74C27.3776 29.8833 27.1385 29.908 26.9445 29.802L18.8911 25.4085C17.9328 25.5361 16.9669 25.6002 16 25.6005C7.1776 25.6005 0 20.3369 0 13.8671C0 7.39733 7.1776 2.13379 16 2.13379V2.13379ZM16 24.5338C16.9755 24.5335 17.9497 24.4648 18.9156 24.3278C19.0294 24.3119 19.1451 24.3327 19.2458 24.3877L26.2326 28.1994L24.4576 23.17C24.3687 22.9189 24.4789 22.6406 24.7156 22.5184C28.6096 20.5104 30.9333 17.2762 30.9333 13.8671C30.9333 7.98561 24.2341 3.20046 16 3.20046C7.76588 3.20046 1.06667 7.98561 1.06667 13.8671C1.06667 19.7486 7.76588 24.5338 16 24.5338Z",
  fill: "url(#paint640_linear_1316:48)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 10.1338H22.9333V11.2005H24V10.1338Z",
  fill: "url(#paint641_linear_1316:48)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8667 10.1338H20.8V11.2005H21.8667V10.1338Z",
  fill: "url(#paint642_linear_1316:48)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7334 10.1338H8.00006V11.2005H19.7334V10.1338Z",
  fill: "url(#paint643_linear_1316:48)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24 12.2666H16.5333V13.3333H24V12.2666Z",
  fill: "url(#paint644_linear_1316:48)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4666 12.2666H14.3999V13.3333H15.4666V12.2666Z",
  fill: "url(#paint645_linear_1316:48)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 12.2666H7.99992V13.3333H13.3333V12.2666Z",
  fill: "url(#paint646_linear_1316:48)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24 14.4004H8V15.4671H24V14.4004Z",
  fill: "url(#paint647_linear_1316:48)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24 16.5332H19.7333V17.5999H24V16.5332Z",
  fill: "url(#paint648_linear_1316:48)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 16.5332H17.6001V17.5999H18.6667V16.5332Z",
  fill: "url(#paint649_linear_1316:48)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5334 16.5332H15.4668V17.5999H16.5334V16.5332Z",
  fill: "url(#paint650_linear_1316:48)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3999 16.5332H7.9999V17.5999H14.3999V16.5332Z",
  fill: "url(#paint651_linear_1316:48)"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint640_linear_1316:48",
  x1: 16,
  y1: 2.13379,
  x2: 16,
  y2: 29.8673,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint641_linear_1316:48",
  x1: 23.4667,
  y1: 10.1338,
  x2: 23.4667,
  y2: 11.2005,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint642_linear_1316:48",
  x1: 21.3334,
  y1: 10.1338,
  x2: 21.3334,
  y2: 11.2005,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint643_linear_1316:48",
  x1: 13.8667,
  y1: 10.1338,
  x2: 13.8667,
  y2: 11.2005,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint644_linear_1316:48",
  x1: 20.2667,
  y1: 12.2666,
  x2: 20.2667,
  y2: 13.3333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint645_linear_1316:48",
  x1: 14.9332,
  y1: 12.2666,
  x2: 14.9332,
  y2: 13.3333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint646_linear_1316:48",
  x1: 10.6666,
  y1: 12.2666,
  x2: 10.6666,
  y2: 13.3333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint647_linear_1316:48",
  x1: 16,
  y1: 14.4004,
  x2: 16,
  y2: 15.4671,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint648_linear_1316:48",
  x1: 21.8667,
  y1: 16.5332,
  x2: 21.8667,
  y2: 17.5999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint649_linear_1316:48",
  x1: 18.1334,
  y1: 16.5332,
  x2: 18.1334,
  y2: 17.5999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint650_linear_1316:48",
  x1: 16.0001,
  y1: 16.5332,
  x2: 16.0001,
  y2: 17.5999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint651_linear_1316:48",
  x1: 11.1999,
  y1: 16.5332,
  x2: 11.1999,
  y2: 17.5999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})));

function SvgAnswer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.553910a3.svg";
export { ForwardRef as ReactComponent };